module.exports = __webpack_public_path__ + "img/perforaciones_4-3_1536.e10e9387.jpg";